import { useEffect, useState } from "react";
import { webUrlNode } from "../../../../constants/appInfo";

export default function EmailWalletSummaryCard() {

  const [data, setData] = useState(null);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    const r = await fetch(`${webUrlNode}/api/email/wallet`);
    const j = await r.json();
    setData(j);
  }

  if (!data) return null;

  const percent =
    data.totalCredits > 0
      ? Math.round(
          (data.usedCredits / data.totalCredits) * 100
        )
      : 0;

  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: 8,
        padding: 14,
        maxWidth: 420
      }}
    >
      <div><b>Total</b> : {data.totalCredits}</div>
      <div><b>Used</b> : {data.usedCredits}</div>
      <div><b>Remaining</b> : {data.remainingCredits}</div>

      <div
        style={{
          marginTop: 8,
          height: 8,
          background: "#eee",
          borderRadius: 4
        }}
      >
        <div
          style={{
            width: percent + "%",
            height: "100%",
            background: "#2563eb",
            borderRadius: 4
          }}
        />
      </div>
    </div>
  );
}
